
<!-- <ng-container>
    <app-secondary-navbar></app-secondary-navbar>
</ng-container> -->
 <div data-content="thr" class="take-action-tab active">
     <div class="esign-card doc_inbox without-consultant-details">
        <div class="inbox-header col-lg-12 pd-0 d-flex flex-wrap justify-content-between pdy-2">
           <div class="col-lg-3 d-flex align-items-center">
              <h4 class="pd-0 mg-0">Inbox</h4>
           </div>
           <div class="col-lg-9 d-flex flex-wrap justify-content-start">
              <div class="col-lg-6 pd-0 pdx-3">
                 <div class="form-group mgb-3 mgb-lg-0">
                    <!-- <label for="SearchInput">Search Input with Icon</label> -->
                    <span class="has-icon">
                      <input 
                        type="Search" 
                        Name="Name" 
                        id="SearchInput" 
                        [(ngModel)]="SearchBy.SearchBySpecificColumns"
                        (keyup.enter)="SearchClick()" 
                        class="form-control" 
                        placeholder="Search by Candidate Name Or Client Name">
                        <i class="con">
                           <button class="bg-none border-0 font-20 pe-all outline-none" (click)="SearchClick()" data-tooltip="Search" data-tooltip-location="bottom">
                             <i class="fa-regular fa-magnifying-glass"></i>
                           </button>
                           <button class="bg-none border-0 font-24 pe-all outline-none" (click)="SearchClick('value')" data-tooltip="Reset" data-tooltip-location="bottom">
                             <i class="fa-regular fa-xmark"></i>
                           </button>
                        </i>
                    </span>
                  </div>
              </div>
       
             
           </div>
        </div>
        <div class="clearfix clear-fix"></div>
        <div class="table_wrap inbox-table-main accordion pd-3 table-respo" id="accordion21">
           <div class="custom_table_head">
              <div class="custom_tr row accordion-group">
                 <div class="custom_th colw-2">&nbsp;</div>
                 <div class="custom_th colw-16">Candidate Name</div>
                 <!-- <div class="custom_th colw-7">GCI ID</div> -->
                  <div class="custom_th colw-20">Subject</div>
                 <div class="custom_th colw-9">Client Name</div>
                 <div class="custom_th colw-9">Start Date</div>
                 <div class="custom_th colw-15">Received From</div>
                 <div class="custom_th colw-13">Received Date</div>
                 <div class="custom_th colw-4">&nbsp;</div>
                 <div class="custom_th colw-4">&nbsp;</div>
                 <div class="custom_th colw-4">&nbsp;</div>
                 <div class="custom_th colw-4">&nbsp;</div>
              </div>
           </div>
           <!-- <div class="accordion-group accordion-level1 custom_tr" style="text-align: center;"  *ngIf="PackageList.length==0">
           <p class="font-12 text-color-pink"> No record found</p>
           </div> -->
           <div class="accordion-group accordion-level1 custom_tr"  *ngFor="let mainitem of PackageList">
              <div class="accordion-heading closed">
                <a class="custom_tr row" >
                    <!-- <div class="accordion-toggle custom_tr row collapsed"> -->
                    <div class="custom_td colw-2 pdx-2" data-tooltip="Click to expand & collapse" data-tooltip-location="right">
                       <!-- <a  data-toggle="active"  data-parent="#accordion21" href="#collapseOne" 
                       (click)="ViewVendorConCompletedDocumentList(mainitem.task_Id,mainitem.emailLogId,mainitem.EmailId)" -->
                       <a id="{{mainitem.emailLogId}}" data-toggle="active" data-parent="#accordion21" href="#collapse{{mainitem.emailLogId}}" 
                       (click)="ViewVendorConCompletedDocumentList(mainitem.task_Id,mainitem.emailLogId,mainitem.EmailId)"
                          class="accordion-toggle collapsed plus-toggle" data-toggle="collapse">&nbsp;</a>
                         
                    </div>
                    <div class="custom_td colw-16 pdl-2">{{mainitem.candidateName}}</div>
                    <!-- <div class="custom_td colw-7">{{mainitem.gcI_ID}}</div> -->
                      <div class="custom_td colw-20 line-limit only-lines-2" data-tooltip-location="top" [attr.data-tooltip]="mainitem.subject">{{mainitem.subject | slice:0:60}}...</div> 
                    <div class="custom_td colw-9" data-tooltip-location="top" [attr.data-tooltip]="mainitem.clientName">{{mainitem.clientName | slice:0:15}}...</div>
                    <div class="custom_td colw-9">{{mainitem.esd}}</div>
                    <div class="custom_td colw-15" data-tooltip-location="top" [attr.data-tooltip]="mainitem.opsExecutiveEmail">{{mainitem.opsExecutiveEmail | slice:0:20}}...</div>
                    <div class="custom_td colw-13">{{mainitem.sentDate}}</div>
                    <div class="custom_td colw-4">
                     <div class="table_actions">
                         <!-- <button (click)="OpenSupportDocPopup()" data-tooltip="View supporting docs" data-tooltip-location="bottom"
                     class="border-0 bg-transparent mgx-2"><i class="oicon oicon-mdsm oicon-viewsupportingdocs"></i></button>  -->
                     <span class="open_popup" data-modalName="upload_adhoc_docs"  data-tooltip="View supporting docs" data-tooltip-location="bottom">
                        <img src="../../assets/images/icons/ic_viewsupportingdocuments.svg" 
                                alt="ic-mail" (click)="OpenSupportDocPopup(mainitem.task_Id)"  data-tooltip="View supporting docs" data-tooltip-location="bottom"/>
                     </span>
                     </div>
                     </div>

                    <div class="custom_td colw-4">
                       <div class="table_actions">
                          <span class="modal_open" data-modalName="emailWrap{{mainitem.emailLogId}}"  data-tooltip="View Email" data-tooltip-location="bottom"><img src="../assets/images/icons/ic-mail-action.svg"
                                alt="ic-mail" (click)="emailWrapPopup(mainitem.emailLogId)"  data-tooltip="View Email" data-tooltip-location="bottom"/></span>
                       </div>
                       <div class="custom_modal" [ngClass]="emailWrapStyle[mainitem.emailLogId]" id="emailWrap{{mainitem.emailLogId}}">
                         <div class="custom_modal_wrap">
                             <div class="custom_modal_header">
                                 <h5 class="modal-title">Email Message</h5>
                                 <button class="close">
                                     <span><img src="../assets/images/icons/ic-close.svg" alt="ic-close" (click)="emailWrapPopup(mainitem.emailLogId)"/></span>
                                 </button>
                             </div>
                             <div class="custom_modal_body">
                                 <div class="email_ttile d-flex align-items-center">
                                     <p>{{mainitem.subject}}</p>                                    
                                 </div>
                                 <div class="email_det">
                                     <div class="row">
                                         <div class="col-sm-12 mail_details">
                                             <table>
                                                 <tr>
                                                     <td><b>From : &nbsp; </b></td>
                                                     <td>{{mainitem.mailFrom}}</td>
                                                   </tr>
                                                   <tr>
                                                     <td>
                                                      <b>On : </b>
                                                    </td>
                                                    <td>
                                                      {{mainitem.sentDate | date: 'MM-dd-yyyy hh:mm:ss'}}
                                                    </td> 
                                                 </tr>
                                                 <tr>
                                                     <td><b>To : &nbsp; </b></td>
                                                     <td>{{mainitem.emailId}}</td>
                                                     
                                                 </tr>
                                                 <tr>
                                                     <td class="pd-0"><b>CC : &nbsp; </b></td>
                                                     <td class="pd-0" style="word-break: break-all;">{{mainitem.mailCC}}</td>
                                                 </tr>
                                             </table>
                                         </div>                                        
                                     </div>
                                 </div>
                                 <div class="email_subject">
                                  <div class="editable" [innerHTML]="sanitizer.bypassSecurityTrustHtml(mainitem.body)" style="text-align: left;" ></div>
                                  
                                 </div>
                             </div>
                         </div>
                     </div>
                    </div>
                    <div  class="custom_td colw-4" >
                       <div class="table_actions">
                          <span class="info-tooltip" data-tooltip="View POC" data-tooltip-location="bottom"><img class="open_popup" src="../assets/images/icons/ic-person-action.svg"
                                alt="ic-mail"  />
                             <div class="action_popup withLogo">
                                <div class="col-sm-12 pd-0 pdy-3 d-flex flex-wrap">
                                   <div
                                      class="col-lg-3 text-center float-none d-flex align-items-center justify-content-center bsr-1">
                                      <img class="" src="../assets/images/ascendion-logo-white.svg" alt="">
                                   </div>
                                   <div class="col-lg-9 float-none pdx-0">
                                      <div class="popup_header border-0">
                                         <h6 class="">Onboarding Contact</h6>
                                         <span class="close_popup">
                                           <i class="fa-regular fa-xmark font-18 color-white"></i>
                                         </span>
                                      </div>
                                      <div class="popup_body pdt-0">
                                         <div class="row">
                                            <div class="col-sm-12 d-flex flex-wrap rej_req_info">
                                               <span class="icon-block">
                                                  <img src="../assets/images/icons/ic-person.svg" alt="ic-person">
                                               </span>
                                               <span class="details-block pdt-1 pdl-1">
                                                  <p>{{mainitem.opsExecutive}}</p>
                                                  <small>{{mainitem.opsExecutive_Designation}}</small>
                                               </span>
                                            </div>
                                            <div class="col-sm-12 d-flex flex-wrap rej_req_info">
                                               <span class="icon-block">
                                                  <img src="../assets/images/icons/ic-mail.svg" alt="ic-person">
                                               </span>
                                               <span class="details-block pdt-1 pdl-1">
                                                  <p>
                                                     <a
                                                        href="mailto:{{mainitem.opsExecutiveEmail}}">{{mainitem.opsExecutiveEmail}}</a>
                                                  </p>
                                               </span>
                                            </div>
                                            <div class="col-sm-12 d-flex flex-wrap rej_req_info">
                                               <span class="icon-block">
                                                  <img src="../assets/images/icons/ic-contact.svg" alt="ic-person">
                                               </span>
                                               <span class="details-block pdt-1 pdl-1">
                                                  <p>
                                                     <a href="tel:{{mainitem.opsExecutive_Phone}}">{{mainitem.opsExecutive_Phone}}</a>
                                                  </p>
                                               </span>
                                            </div>
                                         </div>
                                      </div>
                                   </div>
                                </div>
                             </div>
                          </span>
                       </div>
                    </div>
                    <div class="custom_td colw-4">
                       <div class="table_actions" style="cursor: pointer;">
                          <span data-tooltip="Pin Email" data-tooltip-location="bottom" *ngIf="!mainitem.isPin">
                            <img  src="../assets/images/icons/ic-pin-unactive.svg" alt="ic-mail" 
                            (click)="PinVendorConsselectedDocs(mainitem.task_Id,mainitem.envMstrID,mainitem.emailLogId,mainitem.doc_type)" data-tooltip="Pin Email" data-tooltip-location="bottom"/>
                         </span>
 
                         <span   data-tooltip="Unpin Email" data-tooltip-location="bottom" *ngIf="mainitem.isPin">
                            <img  src="../assets/images/icons/ic-pin-active.svg" alt="ic-mail" 
                            (click)="UnPinVendorConsselectedDocs(mainitem.task_Id,mainitem.envMstrID,mainitem.emailLogId,mainitem.pinID,mainitem.doc_type)" data-tooltip="Pin Email" data-tooltip-location="bottom"/>
                         </span>
                       </div>
                    </div>
                 <!-- </div> -->
                </a> 
              </div>
              <app-partner-child-cons-completeddocs [item]="mainitem.emailLogId" [itemtaskid]="mainitem.task_Id"></app-partner-child-cons-completeddocs>
              
           </div>
           
        </div>
     </div>
     <div class="clear-fix clearfix"></div>
  </div>
  <!-- Supporting docs -->
  <!-- View_Supporting_docs{{mainitem.task_Id}} -->
  <!-- [ngClass]="viewsupportDocStyle[mainitem.task_Id]" -->
  <!-- upload_adhoc_docs -->
  <div class="custom_modal" id="upload_adhoc_docs" [ngStyle]="{'display':AdditionalPopupStyle}">
     <div class="custom_modal_wrap custom_modal-width-md">
       <div class="custom_modal_header pd-2">
         <h5 class="modal-title mg-0">Supporting Doc List</h5>
         <button class="close">
           <span class="d-inline-block cursor-pointer" (click)="OpenSupportDocPopup('')"><i class="fa-regular fa-xmark"></i></span>
         </button>
       </div>
       <div class="custom_modal_body pd-2">
        <div class="documents_mainwrap">
           <div class="doc_row" *ngFor="let item of SupportPackageList;let i = index">
             <div class="doc_type">{{item.docType}}</div> 
             <div class="doc_title" >{{item.docName}}</div>
             <!-- <div class="doc_date">{{item.UploadedDate}}</div>style="width: 60%;" -->
             <div class="doc_date">{{item.sent_date | date: 'MM/dd/yyyy, h:mm:ss a'}}</div>
             <div class="doc_action">
               <span><img src="../assets/images/icons/ic-eye.svg" alt="ic-doc-view" (click)="ViewUploadedFile(item.uploadedFileData,item.uploadedFileName,0)" /></span>
             </div>
           </div>
           <div class="doc_row" *ngIf="SupportPackageList.length == 0">
             No Record Found
           </div>
   
        </div>
         <!-- <div class="table-respo col-lg-12 pd-0">
           <div class="table_wrap col-lg-12 pd-0">
              <div class="custom_tr row" style="border: solid 1px #dee2e6;">
                <div class="custom_th colw-70 text-left">CONTROL</div>
                <div class="custom_th colw-30">VALUE</div>
              </div>
             <div class="custom_tr row" *ngFor="let item of SupportPackageList;let i = index" style="border: solid 1px #dee2e6;">
               <div class="custom_td colw-70 text-left">{{item.docName}}</div>
               <div class="custom_td colw-30"><span class="text-center"><img src="../assets/images/icons/ic-eye.svg" alt="ic-doc-view" (click)="ViewUploadedFile(item.uploadedFileData,item.uploadedFileName,0)" /></span></div>
             </div>
             <div class="custom_tr row" *ngIf="SupportPackageList.length == 0">
               <div class="custom_td colw-100">No Record Found</div>
             </div>
           </div>
         </div> -->
         <div class="clearfix clear-fix"></div>
       </div>
     </div>
   </div>
  <!--  -->
 